import { render, staticRenderFns } from "./RentObjectBeds.vue?vue&type=template&id=6a9c0aa6&scoped=true&lang=pug"
import script from "./RentObjectBeds.vue?vue&type=script&lang=js"
export * from "./RentObjectBeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9c0aa6",
  null
  
)

export default component.exports